// @flow
/* eslint-disable import/prefer-default-export */

import fetch from 'axios';
import _ from 'lodash';
import i18next from 'i18next';
import store from 'app/redux/store';
import { LOGOUT } from 'app/containers/Login/redux';
import { getToken, getUsername } from 'app/utils/user';
// eslint-disable-next-line import/no-dynamic-require
const appConfig = require(`../../apps_config/${decodeURIComponent(_.get(process.env.APP_CONFIG, ['APP_DETAILS', 'EN_NAME'], 'Filimo'))}/config`);

class Client {
  constructor() {
    ['get', 'post', 'put', 'patch', 'del', 'head'].forEach((method : any) => {
      (this : any)[method] = Client.Request(method);
    });
  }

  static Request(method : string) : any {
    return async (url : any, data : any) => {
      const { requestURL, request } = await Client.decorateRequest({ method, url, data });
      return new Promise((resolve : any, reject : any) => {
        fetch(requestURL, request)
          .then((response : any) => Client.checkStatus(response, resolve, reject))
          .catch((error : any) => Client.checkStatus(error, resolve, reject))
          .catch(reject);
      });
    };
  }

  static async parseJSON(res : any) : any {
    if (!res) {
      return {};
    }
    const data = await res.json();
    const { status, ok } = res;
    return { data, ok, status };
  }

  static checkStatus(response : any, resolve : any, reject : any) : any {
    if (_.get(response, ['headers', 'www-authenticate']) === 'jwt') {
      store.dispatch({ type: LOGOUT, data: { skip: true } });
    }
    if (!_.get(response, ['data'])) {
      return reject(response);
    }
    const { status, data } = response;
    if (status >= 200 && status < 300) {
      return resolve({ ...data, status });
    } else if (status >= 300 && status < 400) {
      throw new Error('>= 300 && status < 400');
    } else if (status === 400) {
      throw new Error('Probably is a validation error');
    } else if (status === 403 || status === 401) {
      return resolve({ ...data, status });
    } else if (status === 404) {
      throw new Error('Not Found');
    } else if (status >= 500) {
      throw new Error('Server error');
    }
    return null;
  }

  static isValidUrl(url : string) : boolean {
    return !!url.match(/^(?:(?:(?:https?|ftp):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i);
  }

  static async decorateRequest({ method, url, data } : any) : any {
    const defaults = {
      data,
      method: method.toUpperCase(),
      headers: {},
      mode: 'cors',
    };
    const API_CONFIG = _.get(process.env.APP_CONFIG, 'APP_API', {});
    const isCompleteUrl = this.isValidUrl(url);
    /* $FlowFixMe */
    const requestURL =
      // eslint-disable-next-line no-nested-ternary
      process.env.NODE_ENV === 'development'
        ? isCompleteUrl ? url.substring(_.get(appConfig, ['APP_API', 'PROXY_URL']).length) : `/${API_CONFIG.API_PATH}/${i18next.language.split('-')[0]}/${API_CONFIG.API_VERSION}/${url}`
        : isCompleteUrl ? url : `${API_CONFIG.API_PROTOCOL}://${API_CONFIG.API_SUBDOMAIN ? `${API_CONFIG.API_SUBDOMAIN}.` : ''}${API_CONFIG.API_BASE}/${API_CONFIG.API_PATH}/${i18next.language}/${API_CONFIG.API_VERSION}/${url}`;
    const headers = await Client.getHeaderDataDecoration();
    if (!defaults.data) {
      delete defaults.data;
    }
    return {
      request: {
        ...defaults,
        headers,
      },
      requestURL,
    };
  }

  static async getHeaderDataDecoration() : any {
    const headers = {
      'Content-Type': 'application/json; charset=UTF-8',
      jsonType: 'simple',
      UserAgent: JSON.stringify({
        an: _.get(process.env.APP_CONFIG, ['APP_DETAILS', 'EN_NAME'], ''),
        os: _.get(window, ['webOS', 'platform', 'tv']) ? 'tv_lg' : 'tv',
      }),
      luser: encodeURIComponent(getUsername()),
      Authorization: `Bearer ${getToken() || ''}`,
    };
    Object.keys(headers)
      .forEach((item : string) => {
        if (!headers[item]) {
          delete headers[item];
        }
      });
    return headers;
  }
}

export default new Client();
